export default __webpack_public_path__ + "static/3contenido_pandaxch-0b13ed982b413601c68936f607c49beb.png";